import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
}), 'Navigation');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Navigation.js
// module id = 5001
// module chunks = 2